if (!customElements.get('lakras-mobile-purchase')) {
  customElements.define('lakras-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.root = this.closest('product-info');
      this.panel = this.querySelector('[data-purchase-panel]');
      if (!this.root || !this.panel || !this.root.id.startsWith('MainProduct-')) return;
      this.initialized = true;
      this.sectionId = this.dataset.section;
      this.button = this.panel.querySelector('[data-purchase-button]');
      this.label = this.panel.querySelector('[data-purchase-label]');
      this.price = this.panel.querySelector('[data-purchase-price]');
      this.variant = this.panel.querySelector('[data-purchase-variant]');
      this.feedback = this.panel.querySelector('[data-purchase-feedback]');
      this.mobile = window.matchMedia('(max-width: 749px)');
      document.body.append(this.panel);
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (this.isConnected) this.sync();
        });
      };
      this.onClick = () => {
        this.sync();
        if (this.button.disabled || !this.nativeButton) return;
        this.nativeButton.click();
        this.schedule();
      };
      this.button.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.root, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden', 'value']
      });
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.panel);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule, { passive: true });
      this.sync();
    }

    sync() {
      this.nativeButton = document.getElementById('ProductSubmitButton-' + this.sectionId);
      const form = this.root.querySelector('form[id="product-form-' + this.sectionId + '"]');
      const input = form?.querySelector('[name="id"]');
      const locked = this.dataset.marketSoldOut === 'true';
      const busy = this.nativeButton?.getAttribute('aria-disabled') === 'true' ||
        this.nativeButton?.classList.contains('loading');
      this.button.disabled = locked || !this.nativeButton || this.nativeButton.disabled ||
        !input?.value || input.disabled || busy;
      this.button.setAttribute('aria-busy', busy ? 'true' : 'false');
      this.label.textContent = locked ? this.dataset.soldOut :
        (this.nativeButton?.querySelector('span')?.textContent.trim() || this.dataset.unavailable);
      const priceSource = document.getElementById('price-' + this.sectionId);
      const priceHtml = priceSource?.querySelector('.price')?.outerHTML || '';
      this.price.hidden = this.dataset.editorial === 'true' ||
        !priceHtml || priceSource?.classList.contains('hidden');
      if (this.price.innerHTML !== priceHtml) this.price.innerHTML = priceHtml;
      const selectedJson = this.root.querySelector('variant-selects [data-selected-variant]');
      if (selectedJson) {
        let selected = null;
        try { selected = JSON.parse(selectedJson.textContent); } catch {}
        this.variant.textContent = selected?.title || '';
        this.variant.hidden = !selected?.title || selected.title === 'Default Title';
      }
      const error = this.root.querySelector('product-form .product-form__error-message-wrapper');
      this.feedback.textContent = error && !error.hidden ?
        (error.querySelector('.product-form__error-message')?.textContent || '') : '';
      this.feedback.hidden = !this.feedback.textContent;
      const visible = this.mobile.matches && this.nativeButton &&
        this.nativeButton.getBoundingClientRect().bottom <= 0;
      this.panel.hidden = !visible;
      document.body.classList.toggle('lakras-purchase-visible', Boolean(visible));
      this.measure();
    }

    measure() {
      const height = this.panel.hidden ? 0 : Math.ceil(this.panel.getBoundingClientRect().height);
      document.body.style.setProperty('--lakras-purchase-height', height + 'px');
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.button?.removeEventListener('click', this.onClick);
      this.panel?.remove();
      if (this.initialized) {
        document.body.classList.remove('lakras-purchase-visible');
        document.body.style.removeProperty('--lakras-purchase-height');
      }
      this.initialized = false;
    }
  });
}
